<template>
    <div class="angebot__item border-top border-right border-left border-danger p-4" v-bind:class="{'border-bottom': isLast == true, 'border-bottom-o': isLast == false}">
        <div class="row">
            <div class="col-10">
                <div class="angebot__item-upper row flex-column align-items-start mb-3 mt-2">
                  <div class="angebot__item-block mb-2">
                    <mdb-icon icon="map-marker-alt" class="red-text mr-2" />
                    <span>{{Angebot.ort}}</span>
                  </div>
                  <div class="angebot__item-block mb-2" v-if="Angebot.showname == 1">
                    <mdb-icon far icon="user" class="red-text mr-2" />
                    <span>{{Angebot.name}}</span>
                  </div>
                  <div class="angebot__item-block mb-2" >
                    <mdb-icon far icon="envelope" class="red-text mr-2" />
                    <span>{{Angebot.email }}</span>
                  </div>
                  <div class="angebot__item-block mb-2" v-if="price > 0">
                    <mdb-icon fas icon="euro-sign" class="red-text mr-2" />
                    <span>{{price }}€ {{$t("Suche.Preis")}}</span>
                  </div>
                  </div>
                <div class="angebot__item-lower row d-flex ">
                    <div class="angebot__item-quickfact mr-md-4 btn-danger p-md-2 mr-2 p-1" v-if="Angebot.zimmerart && Angebot.zimmerart != 'kurzzeitigeangebote'"><span v-for="art in arten" v-bind:key="art.value"><span v-if="art.value == Angebot.zimmerart">{{ art.text}}</span></span></div>
                    <div class="angebot__item-quickfact mr-md-4 btn-danger p-md-2 mr-2 p-1" v-if="Angebot.zimmergroesse">{{Angebot.zimmergroesse}}m²</div>
                    <div class="angebot__item-quickfact mr-md-4 btn-danger p-md-2 mr-2 p-1" v-if="validDate(Angebot.freiab)">{{$t("Suche.Ab")}} {{Angebot.freiab}}</div>
                    <div class="angebot__item-quickfact btn-danger p-md-2 p-1" v-if="validDate(Angebot.freibis)">{{$t("Suche.Bis")}} {{Angebot.freibis}}</div>
                </div>
            </div>
            <div class="col-2">
                <div class="btn__wrapper d-flex flex-column h-100 justify-content-around">
                    <div>
                        <a v-on:click="openModal(Angebot.persistence_object_identifier)"><mdb-icon icon="info" class="red-text" /></a>
                    </div>
                    <div>
                    <a v-on:click="removeMerkliste()" v-if="isAufMerkliste">
                        <mdb-icon fas icon="star" class="red-text"/>
                    </a>
                    <a v-on:click="aufMerkliste()" v-else>
                        <mdb-icon far icon="star" class="red-text"/>
                    </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Show from "@/components/angebot/mieter/Show";
    import settings from '@/components/Settings.json';
    import AngebotService from "@/services/AngebotService";
    import EmailService from "@/services/EmailService";
    import ImageService from "@/services/ImageService.js";
    import Lightbox from "@/components/Lightbox";
    import { bus } from '@/main';
    import { mapGetters } from 'vuex'
    export default {
        name: "AngebotItem",
        components: {
            Show,
            Lightbox
        },
        data() {
            return {
                arten: [],
                modalActive: false,
                isSelected: false,
                kommentarAktiv: false,
                kommentar: "",
                selectedAngebot: "",
                lightbox: false,
                lightboxImages: []
            };
        },
        props: {
            Angebot: Object,
            isAufMerkliste: Boolean,
            isLast: {
                type: Boolean,
                required: false,
                default: false,
            }
        },
        methods:{
            toggleLightbox(images){
                this.lightbox = !this.lightbox;
                this.lightboxImages = images;
            },
            validDate(date){
                if(date && date != "0000-00-00 00:00:00"){
                    return true
                } else {
                    return false
                }
            },
            deleteAngebot(id){
                let this_ = this;
                AngebotService.deleteAngebotSelf(id).then(function(){
                    this_.$parent.emitChange();
                    ImageService.deleteImages(id).then(function(){
                    }).catch(function(){

                    });
                }).catch(function(){

                });
            },
            closeKommentar(){
                this.kommentarAktiv = false;
                this.kommentar = "";
                this.selectedAngebot = "";
            },
            openModal(){
                bus.$emit('openModal', this.Angebot);
            },
            closeModal(){
                this.modalActive = false;
            },
            aufMerkliste(){
                let _this = this;
                if(this.userStatus == 0){
                    AngebotService.addAngebotToMerkliste(this.Angebot.persistence_object_identifier, this.userObject.persistence_object_identifier).then(response => {
                        this.$store.dispatch("updateMerkliste", this.userObject.persistence_object_identifier);
                        bus.$emit('merklisteChange', this.Angebot);
                        this.$notify.success({
                            position: 'top right',
                            message: this.$t("Global.Merkliste.Added"),
                            timeout: 3000
                        });

                        this.isAufMerkliste = true;
                    }).catch(error => {
                        console.log("There was an error:", error.response);
                    });
                } else {
                    AngebotService.addAngebotToMerkliste(this.Angebot.persistence_object_identifier, this.userObject.account).then(response => {
                        this.$store.dispatch("updateMerkliste", this.userObject.account);
                        bus.$emit('merklisteChange', this.Angebot);
                        this.$notify.success({
                            position: 'top right',
                            message: this.$t("Global.Merkliste.Added"),
                            timeout: 3000
                        });

                        this.isAufMerkliste = true;

                    }).catch(error => {
                        console.log("There was an error:", error.response);
                    });
                }

            },
            removeMerkliste(){
                if(this.userStatus== 0){
                    AngebotService.removeMerkliste(this.Angebot.persistence_object_identifier, this.userObject.persistence_object_identifier).then(response => {
                        this.$store.dispatch("updateMerkliste", this.userObject.persistence_object_identifier);
                        this.isAufMerkliste = false;
                        bus.$emit('merklisteChange', this.Angebot);
                        this.$notify.warn({
                            position: 'top right',
                            message: this.$t("Global.Merkliste.Deleted"),
                            timeout: 3000
                        });

                    }).catch(error => {
                        console.log("There was an error:", error.response);
                    });
                } else {
                    AngebotService.removeMerkliste(this.Angebot.persistence_object_identifier, this.userObject.account).then(response => {
                        this.$notify.warn({
                            position: 'top right',
                            message: this.$t("Global.Merkliste.Deleted"),
                            timeout: 3000
                        });
                        bus.$emit('merklisteChange', this.Angebot);
                        this.$store.dispatch("updateMerkliste", this.userObject.account);
                    }).catch(error => {
                        console.log("There was an error:", error.response);
                    });
                }

            },
            openKommentarVorhanden(id){
                this.kommentarAktiv = true;
                this.kommentar = this.Angebot.kommentar;
                this.selectedAngebot = id;
            },
            selectOrt(key) {
              if(!key){return}
                key = key.replace(/ /g,'');
                this.places.forEach(option => {
                    if(option.value == key){
                        option.selected = true;
                        this.Angebot.ort = option.text;
                    }
                });
            },
        },
        created(){
            if(!this.Angebot.isFormated){
                if(this.validDate(this.Angebot.freiab)){
                    this.Angebot.freiab = this.$func.formateDateFromDB(this.Angebot.freiab);
                }
                if(this.validDate(this.Angebot.freibis)){
                    this.Angebot.freibis = this.$func.formateDateFromDB(this.Angebot.freibis);
                }
                this.Angebot.isFormated = true;
            }

            this.selectOrt(this.Angebot.ort);
        },
        mounted: function () {
            this.arten = settings.Settings[1][this.$store.getters.lang][0].Zimmerarten;
        },
      computed:{
          price(){
            let miete = parseInt(this.Angebot.miete, 10);
            let nebenkosten = parseInt(this.Angebot.nebenkosten, 10);
            return miete + nebenkosten;
          },
          ...mapGetters([
            'userStatus',
            'userObject',
            'places',
          ])
      }
    }
</script>

<style scoped>
.angebot__item-block i{
  min-width: 16px;
}
</style>